import { render } from "./ServiceType.vue?vue&type=template&id=b175a8f8&scoped=true"
import script from "./ServiceType.vue?vue&type=script&lang=js"
export * from "./ServiceType.vue?vue&type=script&lang=js"

import "./ServiceType.vue?vue&type=style&index=0&id=b175a8f8&scoped=true&lang=css"

import exportComponent from "D:\\learning\\isp_digital\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b175a8f8"]])

export default __exports__